exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui.dropdown .menu>.item:hover{background:none transparent!important}.ui.dropdown .menu>.item.current{background:rgba(0,0,0,.05)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-31f9dd20!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/lib/ModelSelect.vue
// module id = 150
// module chunks = 0